<template>
  <div class="startPage">
    <div class="startText rounded shadow">
      <h3
        v-if="clientMode"
      >To submit a new application, please click the 'New Application' button which will guide you through the process</h3>
      <h3 v-else>
        To get a quote on a new application, please click the 'New Application' button which will guide you through the process.
        <br />You will have the option to submit this application after reviewing the initial offer
      </h3>
      <div class="newButtonWrap">
        <div class="button Enabled" @click="startApplication">
          <h3>New Application</h3>
        </div>
      </div>
    </div>
    <div v-if="!clientMode">
      <h3>This link can be shared with clients to submit an application directly</h3>
      <input class="stretch rounded linkBox" v-model="shareLink" ref="hiddenText" />
      <div class="auto">
        <div @click="copyLink" class="button Enabled">
          <h3>copy link</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    shareLink: {
      set: function() {
        return;
      },
      get: function() {
        let str = window.location.href;
        let loc = str.lastIndexOf("/introducer");
        if (loc === -1) {
          return "error";
        }
        str = str.slice(0, loc);
        str += "/client";
        return str;
      }
    },
    clientMode: function() {
      return this.$store.state.clientMode;
    }
  },
  methods: {
    startApplication: function() {
      this.$store.dispatch("clearForm");
      this.$router.push("1");
    },
    copyLink: function() {
      this.$refs.hiddenText.select();
      document.execCommand("copy");
    }
  }
};
</script>
<style lang="scss" scoped>
.startText {
  padding: 2em;
  text-align: left;
  max-width: 400px;
  @media (max-width: 570px) {
    *{
      max-width: 90vw;
      margin: auto;
    }
  }
}
.linkBox {
  max-width: 400px;
  padding-left: 1em;
  padding-right: 1em;
  text-overflow: ellipsis;
  @media (max-width: 600px) {
    height: 0;
    position: absolute;
    top: -900px;
  }
}
.auto {
  width: auto;
  padding: auto;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1em;
}
.stretch {
  width: 100%;
}
.newButtonWrap {
  margin: 2em;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.startPage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
</style>